import type { SVGAttributes } from "react";

export default function ReviewIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.98862 2.67508C9.36195 1.77758 10.6353 1.77758 11.0086 2.67508L12.7436 6.84674L17.247 7.20841C18.2169 7.28591 18.6103 8.49591 17.8711 9.12924L14.4403 12.0684L15.4878 16.4626C15.7136 17.4092 14.6845 18.1567 13.8545 17.6501L9.99862 15.2951L6.14279 17.6501C5.31278 18.1567 4.28362 17.4084 4.50945 16.4626L5.55695 12.0684L2.12612 9.12924C1.38695 8.49591 1.78029 7.28591 2.75029 7.20841L7.25362 6.84674L8.98862 2.67508Z"
        fill="currentColor"
      />
    </svg>
  );
}
